export const AUTH_ROUTES = {
  landing: '/',
  login: '/login',
  signup: '/signup',
  resetPassword: '/reset-password',
};

export const PORTAL_ROUTES = {
  root: '/portal',
  trips: '/portal/trips',
  documents: '/portal/documents',
  family: '/portal/family',
  account: '/portal/account',
  orders: '/portal/orders',
  adminRoot: '/portal/admin',
  adminOrders: '/portal/admin/orders',
};

export const LIVE_PHOTO_ROUTE = '/live-photo';

export const PORTAL_ITEM_ROUTES = {
  trips: PORTAL_ROUTES.trips,
  documents: PORTAL_ROUTES.documents,
  family: PORTAL_ROUTES.family,
  account: PORTAL_ROUTES.account,
  orders: PORTAL_ROUTES.orders,
  'admin-orders': PORTAL_ROUTES.adminOrders,
};

export function getDefaultRouteForAccount(account) {
  return account ? PORTAL_ROUTES.trips : AUTH_ROUTES.landing;
}
